import { FilePicker } from 'react-file-picker';
import UploadIcon from '@mui/icons-material/FileUploadOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import COLORS from 'lib/colors';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';


export default function FilePickerWithLabel({file, setFile, fileDescriptor, extensions, onChange, onError, isSubmitting}) {

  return (
    <FilePicker
      extensions={extensions}
      onChange={onChange}
      onError={onError}
    >
      <Stack direction='row' sx={{ alignItems: 'center' }}>
        <Button aria-label={`Select ${fileDescriptor}`} variant="outlined" startIcon={<UploadIcon />} disabled={isSubmitting} sx={{ color: COLORS.frenchBlue, borderColor: COLORS.beauBlue, borderStyle: 'dashed', minWidth: 'fit-content' }}>
          {isSubmitting ? 'Processing...' : `Select ${fileDescriptor}`}
        </Button>
        {file &&
          <>
            <Typography sx={{ pl: 2, pr: 1, maxWidth: '50%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{file?.name?.replace(/ /g, "_")}</Typography>
            <IconButton aria-label={`Remove ${fileDescriptor}`} sx={{ p: '2px', color: COLORS.cadetGray }} onClick={() => setFile(undefined)}>
              <CloseIcon />
            </IconButton>
          </>
        }
      </Stack>
    </FilePicker>
  )
}
